// we don't do any error checking on props, we assume the caller has done that already
// color (string), width (number of pixels), and height (number of pixels) should always be specified
const Icon = (props) => (
	<>
		<svg
			width={props.width}
			height={props.height}
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M3 21C2.73478 21 2.48043 20.8946 2.29289 20.7071C2.10536 20.5196 2 20.2652 2 20L2 4C2 3.73478 2.10536 3.48043 2.29289 3.29289C2.48043 3.10535 2.73479 3 3 3L21 3C21.2652 3 21.5196 3.10536 21.7071 3.29289C21.8946 3.48043 22 3.73478 22 4L22 20C22 20.2652 21.8946 20.5196 21.7071 20.7071C21.5196 20.8946 21.2652 21 21 21L3 21ZM17 19L20 19L20 5L17 5L17 19ZM4 19L15 19L15 5L4 5L4 19Z"
				fill={props.color}
			/>
		</svg>
	</>
);

export default Icon;
